import { getBaseUrl } from "../../../utils/requestUtils";

export const ResetPasswordRequest = async (
  email: string,
): Promise<Response> => {
  const baseUrl = await getBaseUrl();
  const response = await fetch(`${baseUrl}/api/v1/account/resetpassword`, {
    body: JSON.stringify({ email }),
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response;
};
